import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/golden-giftbox.svg'


const _withScopeId = n => (_pushScopeId("data-v-c35c1436"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goal-gift-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Goal!"
  })
], -1))
const _hoisted_2 = { class: "goal-text-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextBackButton = _resolveComponent("TextBackButton")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_GoalHistory = _resolveComponent("GoalHistory")!
  const _component_FeatureContainer = _resolveComponent("FeatureContainer")!

  return (_openBlock(), _createBlock(_component_FeatureContainer, { class: "goal-tracking" }, {
    default: _withCtx(() => [
      _createVNode(_component_TextBackButton, { "on-click": _ctx.onBack }, null, 8, ["on-click"]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Typography, {
          variant: "subtitle1",
          class: "goal-text"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Achieve the goal " + _toDisplayString(_ctx.month) + " to unlock the following reward: " + _toDisplayString(_ctx.goalTrackingData.reward), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _createVNode(_component_GoalHistory, {
        "goal-history": _ctx.goalTrackingData.goalTrackingByMonth,
        centered: _ctx.goalTrackingData.period < 5,
        "text-above-dot": true
      }, null, 8, ["goal-history", "centered"])
    ], undefined, true),
    _: 1
  }))
}